module.exports = "/assets/js/09e6f58b7d9cb369d2c01f6fff29dd09.svg";